import { createSelector } from 'reselect'
import addDays from 'date-fns/addDays'
import websiteSelectors from '@nocode-works/template/store/selectors/website'

const websiteOverQuotaList = createSelector(
  websiteSelectors.ownedWebsiteList,
  websites => websites.filter(website => {
    const storage = website.quota.storage.percent
    const bandwidth = website.quota.bandwidth.percent
    return storage.value >= 100 || bandwidth.value >= 100
  }),
)

const bandwidthPerDay = createSelector(
  websiteSelectors.websiteData,
  (website) => {
    if(!website || !website.id || !website.quota || !website.quota.byDay) return []
    const values = website.quota.byDay || []
    const valuesByDay = values.reduce((all, entry) => {
      const dt = new Date(entry.created.value)
      all[dt.getDate()] = entry.size.value
      return all
    }, {})

    const startDate = new Date()
    let currentDate = new Date()
    currentDate.setDate(1)

    const ret = []
    while(currentDate.getMonth() == startDate.getMonth()) {
      ret.push({
        name: currentDate.getDate(),
        value: valuesByDay[currentDate.getDate()] || 0,
      })
      currentDate = addDays(currentDate, 1)
    }
    return ret
  }
)

const selectors = {
  websiteOverQuotaList,
  bandwidthPerDay,
}

export default selectors
